import React from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import cs from 'classnames';

type TFavouriteButtonProps = IProductSnippet['wishlist'];

export const FavouriteButton = (props: TFavouriteButtonProps) => {
    const {onAdd, onRemove, isAdded, isPending, positionIndex} = props;

    if (isAdded) {
        return (
            <button
                className={cs(style.root, {[style.loading]: isPending}, 'snippet-favourite-button')}
                onClick={onRemove}
                data-index={positionIndex}
            >
                <Icon icon={'favourite-new-filled'} className={cs(style.icon, style.icon_applied)} />
            </button>
        );
    }

    return (
        <button
            className={cs(style.root, {[style.loading]: isPending}, 'snippet-favourite-button')}
            onClick={onAdd}
            data-index={positionIndex}
        >
            <Icon icon={'favourite-new'} className={style.icon} />
        </button>
    );
};
